<template>
    <div>

    </div>
</template>

<script>
    export default {
        name: 'Logout',
        mounted(){
            localStorage.clear()
            window.location = 'https://sso.xjtlu.edu.cn/logout'
        }
    }
</script>

<style lang="scss" scoped>

</style>